import React from 'react';
import { motion } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown.ts';
import { COLORS } from '../constants/colors.ts';
import { fadeIn } from '../constants/animations.ts';

interface CountdownSectionProps {
  weddingDate: Date;
}

const CountdownSection: React.FC<CountdownSectionProps> = ({ weddingDate }) => {
  const timeLeft = useCountdown(weddingDate);

  return (
    <motion.section 
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={fadeIn}
      className="py-16 relative overflow-hidden"
      style={{ backgroundColor: COLORS.primary, color: COLORS.secondary }}
    >
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full pattern-bg opacity-20"></div>
      </div>
      
      <h2 className="font-glamour text-3xl font-bold text-center mb-8" style={{ color: COLORS.secondary }}>COUNTDOWN</h2>
      <div className="grid grid-cols-4 gap-6 max-w-xs mx-auto px-4">
        <div className="text-center">
          <div className="font-optima text-3xl font-light mb-2" style={{ color: COLORS.accent }}>{timeLeft.days}</div>
          <div className="font-optima text-xs tracking-wider uppercase">Days</div>
        </div>
        <div className="text-center">
          <div className="font-optima text-3xl font-light mb-2" style={{ color: COLORS.accent }}>{timeLeft.hours}</div>
          <div className="font-optima text-xs tracking-wider uppercase">Hours</div>
        </div>
        <div className="text-center">
          <div className="font-optima text-3xl font-light mb-2" style={{ color: COLORS.accent }}>{timeLeft.minutes}</div>
          <div className="font-optima text-xs tracking-wider uppercase">Minutes</div>
        </div>
        <div className="text-center">
          <div className="font-optima text-3xl font-light mb-2" style={{ color: COLORS.accent }}>{timeLeft.seconds}</div>
          <div className="font-optima text-xs tracking-wider uppercase">Seconds</div>
        </div>
      </div>
    </motion.section>
  );
};

export default CountdownSection;
